import React, {useCallback, useEffect, useState} from 'react';
import CumulativeVolumeReportChart from './component/CumulativeVolumeReportChart';
import CustodianReportDataTable from './component/CustodianReportDataTable';
import {TotalCumulativeVolumeReportType} from './intakeAuditTypes';

export interface CustodianType {
  custodianName: string;
  receivedDate: string;
  emailCompressed: string;
  externallyProcessed: string;
  otherData: string;
  subTotal: string;
  id?: string;
}

interface ByCustodianTabProps {
  totalCumulativeReceivedVolume: TotalCumulativeVolumeReportType;
  custodianData: CustodianType[];
  totalRecordsCount?: number;
  onPagePropsChange?: (itemsPerPage: number, currentPage: number) => void;
  onRefresh?: () => void;
  isChartFailed?: boolean;
  isChartLoading?: boolean;
  size?: number;
  itemPerPage?: number;
}

const ByCustodianTab: React.FC<ByCustodianTabProps> = ({
  totalCumulativeReceivedVolume,
  custodianData,
  totalRecordsCount,
  onPagePropsChange,
  onRefresh,
  isChartFailed,
  isChartLoading,
  size,
  itemPerPage,
}) => {
  const [hoverCustodianData, setHoverCustodianData] =
    useState<CustodianType | null>(null);

  useEffect(() => {
    setHoverCustodianData(null);
  }, [totalRecordsCount, custodianData]);

  const handleCustodianRowHoverEvent = useCallback(
    (event: CustodianType | null) => {
      setHoverCustodianData(event);
    },
    []
  );
  return (
    <>
      <CumulativeVolumeReportChart
        custodianData={custodianData}
        totalCumulativeReceivedVolume={totalCumulativeReceivedVolume}
        hoverCustodian={hoverCustodianData}
        onRefresh={onRefresh}
        isChartFailed={isChartFailed}
        isChartLoading={isChartLoading}
      />
      <CustodianReportDataTable
        custodianData={custodianData}
        onCustodianRowHoverEvent={handleCustodianRowHoverEvent}
        onPagePropsChange={onPagePropsChange}
        totalRecordsCount={totalRecordsCount}
        onRefresh={onRefresh}
        isChartFailed={isChartFailed}
        isChartLoading={isChartLoading}
        size={size}
        itemPerPage={itemPerPage ?? 0}
      />
    </>
  );
};

export default ByCustodianTab;
